<template>
  <Layout> <RouterView /> </Layout>
</template>

<script>
import PageHeader from "@/layouts/page-header";
import Layout from "./workspace";

export default {
  page: {
    title: "Çalışma Alanım",
  },
  components: {
    Layout,
    PageHeader,
  },
  mounted() {
    document.body.setAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-sidebar");
    document.body.removeAttribute("data-sidebar-size");
  },
  data() {
    return {
      title: this.$t("workspace.text"),
    };
  },
};
</script>
